<template>
  <div id="PollList" class="container mx-auto px-4">
    <div class="md:flex mt-4 mb-4">
      <div class="w-full md:w-1/2 mb-2">
        <router-link
          class="hidden md:inline-block bg-push-orange lg:py-2 lg:px-8 py-3 px-4 lg:ml-auto w-full md:w-auto text-white text-center uppercase inline-block"
          v-if="!actionList.length && allPolls.length"
          :to="{ name: 'add-poll' }"
          >Create Poll</router-link
        >
        <a
          class="bg-push-blue cursor-pointer py-2 text-white uppercase pl-2 pr-2 inline-block"
          v-if="actionList.length"
          ><i class="fas fa-arrow-right"></i
        ></a>

        <a
          v-if="actionList.length && allPolls.length"
          class="inline-block cursor-pointer bg-red-500 py-2 mb-2 text-white uppercase pl-6 pr-4 hover:bg-red-600"
          @click="actionDelete"
          >Delete <i class="fas ml-4 fa-trash"></i
        ></a>
        <a
          v-if="actionList.length > 1"
          class="inline-block cursor-pointer bg-push-lightgray py-2 text-white uppercase pl-6 pr-4 hover:bg-push-orange"
          @click="openGroupEdit"
          >Group <i class="fas fa-user-friends"></i
        ></a>
      </div>

      <!-- Group Modal Edit-->
      <modal
        name="group-polls"
        height="auto"
        scrollable="true"
        @before-close="beforeClose"
      >
        <div class="m-2 p-6">
          <div v-if="errors">
            <div
              v-for="(error, i) in errors"
              class="bg-red-500 text-white p-2 mb-4"
            >
              {{ error }}
            </div>
          </div>
          <h4>Enter a name for the group</h4>
          <form>
            <input
              type="text"
              required
              class="py-2 px-4 border search block w-full"
              v-model="groupName"
              placeholder="Enter a group name"
            />
            <em class="block p-2 mt-4"
              >Drag and drop the below list to the order you require</em
            >
            <!-- Grag and drop area -->
            <draggable
              :list="actionList"
              :disabled="!enabled"
              class="mt-4"
              ghost-class="ghost"
              @start="dragging = true"
              @end="dragging = false"
            >
              <div
                class="m-2"
                v-for="(element, index) in actionList"
                :key="index"
              >
                <div class="bg-push-blue py-2 text-white pl-8 pr-4">
                  <b>{{ index + 1 }}. {{ element.name }}</b>
                </div>
              </div>
            </draggable>
            <div class="m-2">
              <em class="block p-2 mt-4 mb-6"
                >Set the start and end dates of your group poll</em
              >
              <div class="flex mb-2">
                <div class="w-1/2 mr-2">
                  <label><b>Starts</b></label>
                  <input
                    class="py-2 px-4 border search block w-full"
                    required
                    type="text"
                    id="start_date"
                    name="start_date"
                    v-model="range.start"
                  />
                </div>
                <div class="w-1/2">
                  <label><b>Ends</b></label>
                  <input
                    class="py-2 px-4 border search block w-full"
                    required
                    type="text"
                    id="end_date"
                    name="end_date"
                    v-model="range.end"
                  />
                </div>
              </div>
              <v-range-selector
                :start-date.sync="range.start"
                :end-date.sync="range.end"
              />
            </div>
            <hr />
            <div class="text-right pt-2">
              <button
                v-if="!editactive"
                @click="actionGroup"
                type="submit"
                class="bg-push-blue py-2 text-white uppercase pl-8 pr-8 mr-2 inline"
              >
                Save
              </button>
              <button
                v-if="editactive"
                @click="editGroup"
                type="submit"
                class="bg-push-blue py-2 text-white uppercase pl-8 pr-8 mr-2 inline"
              >
                Edit Group
              </button>
              <button
                @click="closeGroupModal"
                class="bg-white py-2 text-push-gray border uppercase pl-8 pr-8 inline"
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </modal>

      <div v-if="allPolls.length" class="toolbar w-full md:w-2/3">
        <div class="w-full">
          <input
            v-if="pollDisplay === 'single'"
            type="text"
            v-model="searchQuery"
            class="py-2 px-4 border-2 shadow md:shadow-none border-push-orange md:border-push-lightgray search block w-full md:w-2/3"
            placeholder="Search by poll name"
          />
          <input
            v-if="pollDisplay === 'group'"
            type="text"
            v-model="searchQueryGroup"
            class="py-2 px-4 border search block w-full md:w-2/3"
            placeholder="Search by group name"
          />
        </div>
      </div>
    </div>

    <!-- Extra menu -->
    <div v-if="groupPolls.length" class="mt-2 mb-2">
      <a
        v-bind:class="[
          pollDisplay === 'single'
            ? 'bg-push-blue text-white'
            : 'text-push-gray'
        ]"
        @click="pollDisplay = 'single'"
        class="py-2 uppercase cursor-pointer px-8 inline-block"
        >Single</a
      >
      <a
        v-bind:class="[
          pollDisplay === 'group' ? 'bg-push-blue text-white' : 'text-push-gray'
        ]"
        @click="pollDisplay = 'group'"
        class="py-2 uppercase cursor-pointer px-8 inline-block"
        >Groups</a
      >
      <hr />
    </div>

    <!-- Group -->
    <div
      v-if="groupPolls.length && pollDisplay === 'group'"
      class="previous mb-16"
    >
      <PollList
        @openGroupEdit="openGroupEdit($event)"
        @addtoAction="addtoAction($event)"
        @removeAction="removeAction($event)"
        type="group"
        v-for="(poll, i) in filterItemsGroup(groupPolls)"
        v-bind:key="i"
        :poll="poll"
        :pollkey="poll.groupID"
        :groupResults="filterGroupPolls(poll.polls.keyList)"
      />
    </div>

    <!-- No Polls -->
    <NoPolls v-if="!allPolls.length" />
    <!-- Single -->
    <div
      v-if="thisWeek.length && pollDisplay === 'single'"
      class="previous mb-16"
    >
      <div class="border-b text-push-gray pb-4">This Week</div>
      <PollList
        @addtoAction="addtoAction($event)"
        @removeAction="removeAction($event)"
        type="poll"
        v-for="(poll, i) in filterItems(thisWeek)"
        v-bind:key="i"
        :poll="poll"
        :pollkey="poll.pollkey"
      />
    </div>

    <div
      @addtoAction="addtoAction($event)"
      @removeAction="removeAction($event)"
      type="poll"
      v-if="lastWeek.length && pollDisplay === 'single'"
      class="previous md:mb-16"
    >
      <div class="border-b text-push-gray pb-4 ml-4">Last Week</div>
      <PollList
        @addtoAction="addtoAction($event)"
        @removeAction="removeAction($event)"
        type="poll"
        v-for="(poll, i) in filterItems(lastWeek)"
        v-bind:key="i"
        :poll="poll"
        :pollkey="poll.pollkey"
      />
    </div>

    <div
      v-if="lastPrevious.length && pollDisplay === 'single'"
      class="previous"
    >
      <div class="border-b text-push-gray md:pb-4 pb-2 ml-4 md:ml-auto">
        Previous Polls
      </div>
      <PollList
        @addtoAction="addtoAction($event)"
        @removeAction="removeAction($event)"
        type="poll"
        v-for="(poll, i) in filterItems(lastPrevious)"
        v-bind:key="i"
        :poll="poll"
        :pollkey="poll.pollkey"
      />
    </div>
  </div>
</template>
<script>
import vmodal from "vue-js-modal";
import { mapState } from "vuex";
import firebase from "firebase";
import VRangeSelector from "vuelendar/components/vl-range-selector";
import VueTimepicker from "vue2-timepicker";
import { format } from "path";
import { asyncLoading } from "vuejs-loading-plugin";
import draggable from "vuedraggable";
import moment from "moment";
//import Group from "@/components/dashboard/polls/Group.vue";
import PollList from "@/components/dashboard/polls/Polls.vue";
import NoPolls from "@/components/dashboard/polls/NoPolls.vue";
export default {
  components: {
    VRangeSelector,
    VueTimepicker,
    draggable,
    vmodal,
    PollList,
    NoPolls
  },
  data() {
    return {
      errors: [],
      pollDisplay: "single",
      enabled: true,
      groupEditing: [],
      groupSorter: [],
      dragging: false,
      groupName: null,
      searchQuery: "",
      searchQueryGroup: "",
      dateFilter: "",
      range: {
        start: "",
        end: ""
      },
      question: "",
      todaysDate: null,
      lastSunday: null,
      beforeSunday: null,
      groupPolls: [],
      groupSubPolls: [],
      allPolls: [],
      thisWeek: [],
      lastWeek: [],
      lastPrevious: [],
      isActive: null,
      editactive: null,
      actionList: [],
      hideObject: {
        display: "none"
      },
      timeValueStart: {
        HH: null,
        mm: null
      },
      timeValueEnd: {
        HH: null,
        mm: null
      }
    };
  },
  /* watch: {
    allPolls: {
      handler: function(val, oldVal) {
      },
      deep: true
    }
  },*/
  computed: {
    ...mapState({
      user: "user"
    })
  },
  methods: {
    beforeClose(event) {
      if (event) {
        this.groupEditing = [];
        this.editactive = false;
        this.actionList = [];
      }
    },
    openGroupEdit(key) {
      this.$modal.show("group-polls");
      var vm = this;
      if (key) {
        var firestore = firebase.firestore();
        var groupdocRef = firestore.collection("groups").doc(String(key));
        groupdocRef
          .get()
          .then(
            function(doc) {
              if (doc.exists) {
                vm.editactive = true;
                vm.groupEditing = doc.data();
                vm.actionList = doc.data().polls.keyList;
                vm.groupName = doc.data().group;
                vm.range.end = doc.data().endDate;
                vm.range.start = doc.data().startDate;
                //console.log("Document data:", doc.data());
              } else {
                // doc.data() will be undefined in this case
                console.log("No such document!");
              }
            }.bind(vm)
          )
          .catch(function(error) {
            console.log("Error getting document:", error);
          });
      }
    },
    closeGroupModal() {
      this.$modal.hide("group-polls");
      this.groupEditing = [];
      this.editactive = false;
      this.actionList = [];
    },
    addtoAction(object) {
      var vm = this;
      vm.actionList.push(object);
    },
    removeAction(id) {
      var result = null;
      let actionList = this.actionList;
      var vm = this;
      actionList.forEach((item, i) => {
        if (item == id) {
          console.log("exists" + id, item, i);
          result = i;
        }
      });
      vm.actionList.splice(result, 1);
    },

    filterItems: function(Search) {
      var app = this;

      return Search.filter(function(Search) {
        let regex = new RegExp("(" + app.searchQuery + ")", "i");
        //console.log(Search.question.match(regex))
        var Find = Search.question.match(regex);

        return Find;
      });
    },

    filterItemsGroup: function(Search) {
      var app = this;

      return Search.filter(function(Search) {
        let regex = new RegExp("(" + app.searchQueryGroup + ")", "i");
        //console.log(Search.group.match(regex))
        var Find = Search.group.match(regex);

        return Find;
      });
    },

    loadPolls: function() {
      var vm = this;
      var sunday = this.lastSunday;
      var beforesunday = this.beforeSunday;
      var firestore = firebase.firestore();

      firestore
        .collection("polls")
        .where("author", "==", this.user.data.email)
        .onSnapshot(function(querySnapshot) {
          //var cities = [];
          vm.allPolls = [];
          vm.lastWeek = [];
          vm.thisWeek = [];
          vm.lastPrevious = [];
          querySnapshot.forEach(
            function(doc, i) {
              var d = doc.data();
              //console.log(doc);
              var id = doc.id;
              vm.pollID = doc.id;
              vm.allPolls.push(d);

              //Get Sunday
              if (d.startDate <= sunday && d.startDate >= beforesunday) {
                vm.lastWeek.push(d);
              }

              if (d.startDate > sunday) {
                vm.thisWeek.push(d);
              }

              if (d.startDate < beforesunday) {
                vm.lastPrevious.push(d);
              }
            }.bind(vm)
          );
        });
    },

    clearPage: function() {
      this.$loading(true);

      setTimeout(
        function() {
          if (!this.allPolls.length) {
            this.hideObject.display = "block";
          } else {
            this.hideObject.display = "none";
          }

          this.$loading(false);
        }.bind(this),
        2000
      );
    },

    getlastSunday: function() {
      var now = new Date();
      var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      var Sunday = new Date(today.setDate(today.getDate() - today.getDay()));

      // reformat
      var month = ("0" + (Sunday.getMonth() + 1)).slice(-2);
      var date = ("0" + Sunday.getDate()).slice(-2);
      var year = Sunday.getFullYear();
      var formattedDate = year + "-" + month + "-" + date;
      this.lastSunday = formattedDate;
      var beforeSunday = new Date(Sunday.setDate(Sunday.getDate() - 7));

      //Before Sunday
      var month = ("0" + (beforeSunday.getMonth() + 1)).slice(-2);
      var date = ("0" + beforeSunday.getDate()).slice(-2);
      var year = beforeSunday.getFullYear();
      var formattedDatebeforeSunday = year + "-" + month + "-" + date;
      this.beforeSunday = formattedDatebeforeSunday;
    },

    dateFormatter: function(startDate) {
      var start = new Date(startDate);
      var month = ("0" + (start.getMonth() + 1)).slice(-2);
      var date = ("0" + start.getDate()).slice(-2);
      var year = start.getFullYear();
      var formattedDate = date + "/" + month + "/" + year;
      return formattedDate;
    },

    currentDate: function() {
      var today = new Date();
      var month = ("0" + (today.getMonth() + 1)).slice(-2);
      var date = ("0" + today.getDate()).slice(-2);
      var year = today.getFullYear();
      var formattedDate = year + "-" + month + "-" + date;
      this.todaysDate = formattedDate;
      this.range.start = formattedDate;
    },

    dateProcessing: function(endDate, endTime) {
      var today = this.todaysDate;
      if (endDate <= today) {
        var diffDays =
          "ended <em>" +
          moment(endDate)
            .startOf("day")
            .fromNow() +
          "</em>";
      } else {
        var diffDays =
          "ends <em>" +
          moment(endDate)
            .endOf("day")
            .fromNow() +
          "</em>";
      }
      return diffDays;
    },

    actionDelete: function(e) {
      var keyList = this.actionList;
      e.preventDefault();
      e.target.blur();
      var firestore = firebase.firestore();
      keyList.forEach(key => {
        if (key.type === "poll") {
          //console.log(key);
          const remove = firestore
            .collection("polls")
            .doc(key.id)
            .delete()
            .then(function() {
              // console.log("Document successfully deleted!");
            })
            .catch(function(error) {
              // console.error("Error removing document: ", error);
            });

          asyncLoading(remove)
            .then()
            .catch();
        }
        // Delete a group
        if (key.type === "group") {
          var resetList = key.polls;

          resetList.forEach(reset => {
            var polldocRef = firestore.doc("polls/" + reset.id);
            var grouped = polldocRef
              .update({
                group: {},
                groupID: "",
                eventpoll: 0,
                event: null
              })
              .then(function() {
                console.log("Group successfully updated!");
                //Update Groups
              })
              .catch(function(error) {
                console.error("Error updating document: ", error);
              });
          });
          console.log(key);
          const remove = firestore
            .collection("groups")
            .doc(String(key.id))
            .delete()
            .then(function() {
              console.log("Document successfully deleted!");
            })
            .catch(function(error) {
              // console.error("Error removing document: ", error);
            });
          asyncLoading(remove)
            .then()
            .catch();
        }
      });

      this.actionList = [];
      this.pollDisplay = "single";
      this.clearPage();
    },
    getGroups() {
      var vm = this;
      var user = this.user.data.uid;
      //console.log(user);
      var firestore = firebase.firestore();

      firestore
        .collection("groups")
        .where("user", "==", user)
        .onSnapshot(
          function(querySnapshot) {
            vm.groupPolls = [];
            querySnapshot.forEach(function(doc) {
              var groups = doc.data();
              vm.groupPolls.push(groups);
            });
          }.bind(vm)
        );
    },

    filterGroupPolls: function(keyData) {
      let groupSubPolls = [];
      let allData = this.allPolls;
      keyData.forEach(key => {
        //Search Through All data
        allData.forEach(poll => {
          if (key.id === poll.pollkey) {
            //console.log(poll.pollkey)
            groupSubPolls.push(poll);
          }
        });
      });
      return groupSubPolls;
    },

    actionGroup: function(e) {
      var user = this.user.data.uid;
      var firestore = firebase.firestore();
      var keyList = this.actionList;
      var htmlList = "";

      e.preventDefault();
      e.target.blur();

      //Get Group name
      var code = Math.floor(100000 + Math.random() * 900000);

      var firestore = firebase.firestore();

      this.errors = [];

      if (!this.groupName) {
        this.errors.push("Please give this group a name!");
      }
      if (!this.range.end) {
        this.errors.push("Please give this group an end date!");
      }

      if (this.groupName && this.range.end) {
        var groupdocRef = firestore.doc("groups/" + code);
        var groups = groupdocRef
          .set({
            group: this.groupName,
            startDate: this.range.start,
            endDate: this.range.end,
            startTime: "00:00",
            endTime: "00:00",
            user: user,
            groupID: code,
            total: 0,
            visits: 0,
            polls: {
              keyList
            }
          })
          .then(function() {
            console.log("Group successfully updated!");
          })
          .catch(function(error) {
            console.error("Error updating document: ", error);
          });

        keyList.forEach(key => {
          //console.log(key);

          var polldocRef = firestore.doc("polls/" + key.id);
          var grouped = polldocRef
            .update({
              group: { name: this.groupName, id: code },
              groupID: code
            })
            .then(function() {
              console.log("Group successfully updated!");
              //Update Groups
            })
            .catch(function(error) {
              console.error("Error updating document: ", error);
            });

          asyncLoading(grouped)
            .then()
            .catch();
        });

        this.actionList = [];
        this.pollDisplay = "group";
        this.clearPage();
        this.closeGroupModal();
      }
    },

    editGroup: function() {
      event.preventDefault();
      event.target.blur();

      //Get Group name

      var firestore = firebase.firestore();

      var groupdocRef = firestore.doc("groups/" + this.groupEditing.groupID);
      var groups = groupdocRef
        .update({
          group: this.groupName,
          startDate: this.range.start,
          endDate: this.range.end,
          startTime: this.groupEditing.startTime,
          endTime: this.groupEditing.endTime,
          polls: { keyList: this.actionList }
        })
        .then(function() {
          console.log("Group successfully updated!");
        })
        .catch(function(error) {
          console.error("Error updating document: ", error);
        });

      //Get Current poll

      let keyList = this.groupEditing.polls.keyList;

      keyList.forEach(key => {
        //console.log(key);

        var polldocRef = firestore.doc("polls/" + key.id);
        var grouped = polldocRef
          .update({
            group: {
              name: this.groupEditing.group,
              id: this.groupEditing.groupID
            }
          })
          .then(function() {
            console.log("Group successfully updated!");
            //Update Groups
          })
          .catch(function(error) {
            console.error("Error updating document: ", error);
          });

        asyncLoading(grouped)
          .then()
          .catch();
      });

      this.actionList = [];
      this.pollDisplay = "group";
      this.clearPage();
      this.closeGroupModal();
    }
  },
  mounted: function() {
    this.clearPage();
    this.currentDate();
    this.getlastSunday();
    this.loadPolls();
    this.getGroups();
  }
};
</script>
